import { useEffect } from 'react';

export default ({ onResize }) => {
	useEffect(() => {
		const handleOnResize = () => {
			if (onResize)
				onResize({
					width: window.innerWidth,
					height: window.innerHeight,
				});
		};

		handleOnResize();

		window.addEventListener('resize', handleOnResize);
		window.addEventListener('orientationchange', handleOnResize);

		return () => {
			window.removeEventListener('resize', handleOnResize);
			window.removeEventListener('orientationchange', handleOnResize);
		};
	}, []);
};
